module.exports = __webpack_public_path__ + "static/app-dashboard-48b8efe2984f0f283de48665f29fc868.png";